module.exports = __webpack_public_path__ + "static/media/15.e28cf021.gif";